export default function getFieldsFromCol(tab, col) {
  let fields = {}
  if (tab.children[col]) {
    tab.children[col].forEach(item => {
      fields[item.key] = typeof item.defaultValue !== "undefined" ? item.defaultValue : null
    })
  }
  return fields
}